<script>
	import Header from "../components/Header.svelte";
	import { api_host, domain_code_store } from "../stores.js";
	import { doFetch } from '../utils/Fetching.svelte';
	import { toast } from '@zerodevx/svelte-toast';
	import * as yup from 'yup';
	import { toast_message } from '../utils/toast_message.js';


	let domain_code = '';
	let search_address = '';

	domain_code_store.subscribe(value => {
		domain_code = value;
	});

	const handle_address = async () => {
		const res = await doFetch(
			`${api_host}/api/ex/property_info`,
			'POST',
			{ q: JSON.stringify(search_address) },
			{ 'DomainCode': domain_code, 'Content-Type': 'application/json' }
		);
		if (res.data) {
			const { address, city, state, lot_size, building_stories } = res.data;
			await doFetch(
				`${api_host}/api/ex/record/search_address`,
				'POST',
				{
					domain_name: window.location.host,
					search_key: search_address,
					lot_size,
					stories: building_stories,
					address,
					city,
					state,
				},
				{ 'DomainCode': domain_code, 'Content-Type': 'application/json' }
			);
			window.location.href = `/booking?address_data=${btoa(JSON.stringify(res.data))}`;
		} else {
			toast_message('Invalid Address', 3000);
		}
	}
</script>


<Header />

<div class="formholder">
	<div class="pagetitle">
	</div>

	<div class='search_container'>
		<input
			type="text"
			placeholder="Search address for instant quote..."
			name="search"
			on:keyup={(e) => {
				if (e.key === 'Enter') {
					handle_address();
				}
			}}
			bind:value={search_address}
		/>
		<button type="submit" on:click={() => { handle_address(); }}>
			<i class="fa fa-search"></i>
		</button>
	</div>
</div>


<style>
	.formholder {
		width: 80%;
		margin-left: auto;
		margin-right: auto;
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-template-areas: "pt pt"
												 "mn mn";
	}
	@media (max-device-width: 1024px), (max-width: 1023px) {
		.formholder {
			width: 90%;
			margin-left: auto;
			margin-right: auto;
			display: grid;
			grid-template-columns: 1fr;
			grid-template-areas: "pt"
													 "mn";
		}
	}
	.pagetitle {
			grid-area: pt;
			border-bottom: solid 1px #E9E9EC;
			font-size: 3rem;
			font-weight: bold;
	}
	.search_container {
		margin-top: 15px;
		grid-area: mn;
	}
	.search_container input[type=text] {
		padding: 10px;
		font-size: 17px;
		border: 1px solid grey;
		float: left;
		width: 80%;
		background: #f1f1f1;
	}
	.search_container button {
		float: left;
		width: 20%;
		padding: 10px;
		background: #2196F3;
		color: white;
		font-size: 17px;
		border: 1px solid grey;
		border-left: none;
		cursor: pointer;
	}
	.search_container button:hover {
		background: #0b7dda;
	}
	.search_container::after {
		content: "";
		clear: both;
		display: table;
	}
	input {
		outline: none ! important;
	}
</style>